var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecretScope24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 2.25C1.34359 2.25 1.00781 2.58579 1.00781 3L1.00791 21C1.00791 21.4142 1.3437 21.75 1.75792 21.75C2.17213 21.75 2.50791 21.4142 2.50791 21L2.50781 3C2.50781 2.58578 2.17202 2.25 1.75781 2.25Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.242 2.25123C21.8278 2.25123 21.492 2.58702 21.492 3.00123L21.4921 21.0012C21.4921 21.4154 21.8279 21.7512 22.2421 21.7512C22.6563 21.7512 22.9921 21.4154 22.9921 21.0012L22.992 3.00122C22.992 2.58701 22.6562 2.25123 22.242 2.25123Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 2.25122C1.34359 2.25122 1.00781 2.58701 1.00781 3.00122L1.00791 21.0012C1.00791 21.4154 1.3437 21.7512 1.75792 21.7512C2.17213 21.7512 2.50791 21.4154 2.50791 21.0012L2.50781 3.00121C2.50781 2.587 2.17202 2.25122 1.75781 2.25122Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 7C12.3997 7 12.7237 7.32399 12.7237 7.72365V10.6818L15.23 9.08684C15.5672 8.87227 16.0145 8.97166 16.2291 9.30885C16.4436 9.64602 16.3442 10.0933 16.0071 10.3079L13.348 12L16.0071 13.6921C16.3442 13.9067 16.4436 14.354 16.2291 14.6912C16.0145 15.0283 15.5672 15.1278 15.23 14.9131L12.7237 13.3182V16.2763C12.7237 16.676 12.3997 17 12.0001 17C11.6004 17 11.2764 16.676 11.2764 16.2763V13.3183L8.77015 14.9131C8.43296 15.1278 7.98569 15.0283 7.77112 14.6912C7.55655 14.354 7.65595 13.9067 7.99312 13.6921L10.6522 12L7.99312 10.3079C7.65595 10.0933 7.55655 9.64602 7.77112 9.30885C7.98569 8.97166 8.43296 8.87227 8.77015 9.08684L11.2764 10.6817V7.72365C11.2764 7.32399 11.6004 7 12.0001 7Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecretScope24);
export default __webpack_public_path__ + "static/media/icon_secret_scope_24.87a4a7a8f54885a1d38964621bd9ee86.svg";
export { ForwardRef as ReactComponent };